import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";
const deleteWarnDoc = "/api/telcoServices/deleteWarnDoc";
const baseApiFile = "/api/revenue/telcoServices/file?file_id=";

export default class DebtGeneral {
  private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;

  public getAllDebtGenerals(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company/feeInfor", querySearch)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  public dowloadExcel(querySearch?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("/api/business/company/debt-general-excel", querySearch, { responseType: "blob" })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
